export default __webpack_public_path__ + "img/buFJPpQu.ff554c22.svg";